import { toPathKey } from '../../basic/locationKey';
import { NavigationItemInMenu, NavigationItemResponse } from './types';

const findNavigationItemInMenuInternal = (
  submenu: NavigationItemResponse[],
  pathKey: string,
  breadcrumbs: NavigationItemResponse[] = [],
): NavigationItemInMenu | null => {
  for (const item of submenu) {
    if (item.url === pathKey) {
      return { ...item, breadcrumbs };
    }
    const breadcrumbsForChildren = [...breadcrumbs, item];
    if (item.children) {
      const found = findNavigationItemInMenuInternal(item.children, pathKey, breadcrumbsForChildren);
      if (found !== null) {
        return found;
      }
    }
    if (pathKey.startsWith(item.url) && item.url !== '/') {
      return { ...item, breadcrumbs: breadcrumbsForChildren };
    }
  }
  return null;
};

export const findNavigationItemInMenu = (
  menu: NavigationItemResponse[],
  pathKey: string,
): NavigationItemInMenu | null => {
  pathKey = toPathKey(pathKey);
  const startingBreadcrumbs: NavigationItemResponse[] = (menu.length === 0 || pathKey === '/' ? [] : [menu[0]]);
  return findNavigationItemInMenuInternal(menu, pathKey, startingBreadcrumbs);
};
